import React from 'react';

const HealthCheck = () => {
        return(
        <div><h3>dev media console frontend service is running on 3000</h3></div>
        )
}
export default HealthCheck;